var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ErrorBoundary } from '@folio/stripes/components';
import { Settings } from '@folio/stripes/smart-components';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { TitleManager, useStripes } from '@folio/stripes/core';
import AllCalendarView from './AllCalendarView';
import CurrentAssignmentView from './CurrentAssignmentView';
import MonthlyCalendarPickerView from './MonthlyCalendarPickerView';
export var CalendarSettings = function (props) {
    var intl = useIntl();
    var stripes = useStripes();
    var paneTitle = intl.formatMessage({ id: 'ui-calendar.meta.titleSettings' });
    return (React.createElement(ErrorBoundary, null,
        React.createElement(Settings, __assign({}, props, { navPaneWidth: "30%", pages: [
                {
                    route: 'all/',
                    label: (React.createElement(TitleManager, { page: paneTitle, stripes: stripes },
                        React.createElement(FormattedMessage, { id: "ui-calendar.allCalendarView.title" }))),
                    component: AllCalendarView,
                    perm: 'ui-calendar.view'
                },
                {
                    route: 'active/',
                    label: (React.createElement(FormattedMessage, { id: "ui-calendar.currentAssignmentView.title" })),
                    component: CurrentAssignmentView,
                    perm: 'ui-calendar.view'
                },
                {
                    route: 'monthly/',
                    label: (React.createElement(FormattedMessage, { id: "ui-calendar.monthlyCalendarView.title" })),
                    component: MonthlyCalendarPickerView,
                    perm: 'ui-calendar.view'
                }
            ], paneTitle: React.createElement(FormattedMessage, { id: "ui-calendar.meta.title" }) }))));
};
export default CalendarSettings;
